import { useTranslation } from 'react-i18next';
import { Button, PageHeader } from 'components';
import { Col, Divider, Row } from 'antd';
import { Link } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import Filters from 'components/filters';
import styles from './style.module.scss';
import { useFacilityCalendar } from './useFacilityCalendar';
import Calendar from 'components/calendar';

const CalendarPage = () => {
  const { t } = useTranslation();
  const { filters, data } = useFacilityCalendar();

  return (
    <>
      <PageHeader title={t('CALENDARIO FACILITY').toUpperCase()}>
        <Row gutter={16}>
          <Col style={{ opacity: 0 }}>
            <Link to={'new'}>
              <Button big icon={<PlusOutlined />}>
                {t('NUOVO')}
              </Button>
            </Link>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <div>
          <Calendar data={data.data} />
          {/*<Calendar*/}
          {/*  data={[*/}
          {/*    {*/}
          {/*      end: '2022-04-01 23:59:59',*/}
          {/*      source_id: 4,*/}
          {/*      source_type: 'extrastock_offer',*/}
          {/*      start: '2022-04-01 00:00:00',*/}
          {/*      title: 'SOV - TEST TANIA-Unità 123',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      end: '2022-04-02 23:59:59',*/}
          {/*      source_id: 5,*/}
          {/*      source_type: 'extrastock_offer',*/}
          {/*      start: '2022-04-02 00:00:00',*/}
          {/*      title: 'SOV - TEST TANIA-Unità 123',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      end: '2022-04-22 19:11:59',*/}
          {/*      source_id: 13,*/}
          {/*      source_type: 'facility_operation',*/}
          {/*      start: '2022-04-20 19:11:00',*/}
          {/*      title: 'Manutenzione ordinaria',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      end: '2022-04-15 12:10:59',*/}
          {/*      source_id: 322,*/}
          {/*      source_type: 'facility_operation',*/}
          {/*      start: '2022-04-14 12:10:00',*/}
          {/*      title: 'Manutenziona straordinaria',*/}
          {/*    },*/}
          {/*  ]}*/}
          {/*/>*/}
        </div>
      </div>
    </>
  );
};

export default CalendarPage;
